import {post, get, del, put} from '@/api';
import * as WEB from '@/api/web';
import * as USER from '../constants/user';
import queryString from "query-string";

export default {

  /**
   * List of users.
   *
   * @param commit
   * @param param
   * @returns {*}
   */
  [USER.ACTION_LIST_USER]: ({commit}, param) => {
    const qs = queryString.stringify(param, {arrayFormat: 'bracket'});
    const result = get(`/user?${qs}`);

    result.then((res) => {
      commit(USER.MUTATE_LIST_USER, res.data);
    });

    return result;
  },

  [USER.ACTION_GET_USER]: ({commit}, id) => {
    return get(`/user/${id}`);
  },

  /**
   * Authenticate.
   *
   * @param commit
   * @param param
   * @returns {Promise<T>}
   */
  [USER.AUTHENTICATE]: ({commit}, param) => {
    const response = WEB.post(`/authenticate`, param);

    response.then((res) => {
      const data = res.data;

      localStorage.setItem('token', data.token);
      localStorage.setItem('user', JSON.stringify(data));

      window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
      commit(USER.MUTATE_USER, data);
    });

    return response;
  },

  [USER.ACTION_DELETE]: ({commit}, payload) => {
    return del(`/user/${payload.id}`);
  },

  /**
   * Update user
   * @param commit
   * @param id
   * @param payload
   * @returns {*}
   */
  [USER.ACTION_UPDATE]: ({commit}, {id, payload, selfUpdate}) => {
    console.log(payload, 'payload');
    const result = put(`/user/${id}`, payload);

    // No need to mutate the data when we're not updating
    // the data of user that logged in
    if (selfUpdate) {
      result.then(res => {
        localStorage.setItem('user', JSON.stringify(res.data));
        commit(USER.MUTATE_USER, res.data);
      });
    }

    return result;
  },

  /**
   * Add user
   * @param commit
   * @param payload
   * @returns {*}
   */
  [USER.ACTION_ADD]: ({commit}, payload) => {
    return post(`/user`, payload);
  },
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js